import React from 'react'
import {ImSpinner2} from "react-icons/im";

const Loader = ({className}) => {
    return (
        <div className={`${className} flex justify-center text-center`}>
            <ImSpinner2 className="animate-spin h-5 w-5 mr-3"/>
        </div>
    )
}

export default Loader